<template>
  <div class="wrapper">
    <side-bar data-background-color="white">
      <template slot="links">
        <sidebar-link to="/account" name="Account" :image="require('@/assets/img/sidenav/account.png')" :image-active="require('@/assets/img/sidenav/account_active.png')" />
        <sidebar-link to="/receipt-history" name="Receipt History" :image="require('@/assets/img/sidenav/receipt_history.png')" :image-active="require('@/assets/img/sidenav/receipt_history_active.png')" />
        <sidebar-link to="/docs" name="API Docs" :image="require('@/assets/img/sidenav/api_docs.png')" />
        <sidebar-link to="/settings" name="Settings" :image="require('@/assets/img/sidenav/settings.png')" :image-active="require('@/assets/img/sidenav/settings_active.png')" />
      </template>
      <mobile-menu>
        <li class="nav-item">
          <a href="javascript:void(0)" @click="signOut" class="nav-link">Log Out</a>
        </li>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar />
      <dashboard-content @click.native="toggleSidebar" />
    </div>
    <div class="modals">
      <account-details-modal
        ref="accountDetailsModal"
      />
      <create-api-key-modal
        ref="createApiKeyModal"
      />
      <edit-api-key-modal
        ref="editApiKeyModal"
      />
      <delete-api-key-modal
        ref="deleteApiKeyModal"
      />
      <subscription-plans-modal
        ref="subscriptionPlansModal"
      />
      <all-invoices-modal
        ref="allInvoicesModal"
      />
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import ModalBus from '@/buses/modal';

import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";

import AccountDetailsModal from '../../modals/AccountDetails'

import CreateApiKeyModal from '../../modals/CreateApiKey'
import EditApiKeyModal from '../../modals/EditApiKey'
import DeleteApiKeyModal from '../../modals/DeleteApiKey'

import SubscriptionPlansModal from '../../modals/SubscriptionPlans'
import AllInvoicesModal from '../../modals/AllInvoices'

export default {
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu,
    AccountDetailsModal,
    CreateApiKeyModal,
    EditApiKeyModal,
    DeleteApiKeyModal,
    SubscriptionPlansModal,
    AllInvoicesModal,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    signOut() {
      this.$store.dispatch('userSignOut')
    }
  },
  created: function() {
    ModalBus.$on('accountDetailsModal.open', (userAccountDetails) => {
      if (this.$refs.accountDetailsModal) {
        this.$refs.accountDetailsModal.open(userAccountDetails)
      }
    })
    ModalBus.$on('createApiKeyModal.open', () => {
      if (this.$refs.createApiKeyModal) {
        this.$refs.createApiKeyModal.open()
      }
    })
    ModalBus.$on('editApiKeyModal.open', (item) => {
      if (this.$refs.editApiKeyModal) {
        this.$refs.editApiKeyModal.open(item)
      }
    })
    ModalBus.$on('deleteApiKeyModal.open', (item) => {
      if (this.$refs.deleteApiKeyModal) {
        this.$refs.deleteApiKeyModal.open(item)
      }
    })
    ModalBus.$on('subscriptionPlansModal.open', () => {
      if (this.$refs.subscriptionPlansModal) {
        this.$refs.subscriptionPlansModal.open()
      }
    })
    ModalBus.$on('allInvoicesModal.open', () => {
      if (this.$refs.allInvoicesModal) {
        this.$refs.allInvoicesModal.open()
      }
    })
  },
  beforeDestroy: function() {
    ModalBus.$off('accountDetailsModal.open')
    ModalBus.$off('createApiKeyModal.open')
    ModalBus.$off('editApiKeyModal.open')
    ModalBus.$off('deleteApiKeyModal.open')
    ModalBus.$off('subscriptionPlansModal.open')
    ModalBus.$off('allInvoicesModal.open')
  }
};
</script>
